// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m5-0";
export var fileList = "_m5-2";
export var removeFileButton = "_m5-1";